import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { CentralEventDetailInterface } from '../definitions/central-event-detail-interface';

@Injectable()
export class CentralEventDetailByIdService {

  public constructor(private client: HttpClient, private configService: ConfigService) {}

  public detail(id: string): Observable<CentralEventDetailInterface> {
    const url = `${this.configService.config.rest.apiV2Url}/central-events/${id}`;

    return this.client.get<CentralEventDetailInterface>(url).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
